module.exports = __webpack_public_path__ + "media/images/icons/outlined/crown-d00dc5aec98ba4052d94a016a361b8ba.svg";